<template>
  <div :class="['nav', theme === 'light' ? 'nav-light' : 'nav-dark']">
   
    <div class="logo">
       <a href="/"> 
          <div>

            <img src="~@/../static/logo.png" alt="" />

          </div>
       </a>

      <a href="/">
        日本出行智慧伴侣
      </a>

    </div>
 <div class="right_nav">
    <div class="nav_t1 nav_act" @click="jump('/')" v-if="index == 0">
      <span> {{this.$lang('37396')}} </span>
    </div>
    <div v-else class="nav_t1" @click="jump('/')">
      <span> {{this.$lang('37396')}} </span>
    </div>

    <div class="nav_t1 nav_act" @click="jump('/shop')" v-if="index == 4">
      <span> {{ $lt('景点门票') }} </span>
    </div>
    <div v-else class="nav_t1" @click="jump('/shop')">
      <span> {{ $lt('景点门票') }} </span>
    </div>

    <div class="nav_t1 nav_act" @click="jump('/seat')" v-if="index == 2">
      <span> {{this.$lang('37398')}}</span>
    </div>
    <div v-else class="nav_t1" @click="jump('/seat')">
      <span> {{this.$lang('37398')}}</span>
    </div>

    <div class="nav_t1 nav_act" @click="jump('/bus_list')" v-if="index == 1">
      <span> {{ this.$lang('37397') }}</span>
    </div>
    <div v-else class="nav_t1 " @click="jump('/bus_list')">
      <span> {{ this.$lang('37397') }}</span>
    </div>

    <div class="nav_t1 nav_act" @click="jump('/scenic')" v-if="index == 3">
      <span> {{ this.$lang('37414')}}</span>
    </div>
    <div v-else class="nav_t1" @click="jump('/scenic')">
      <span> {{ this.$lang('37414')}}</span>
    </div>

    <!-- <div class="nav_t1">
        <span>{{this.$lang('37399')}}</span>
      </div> -->

    <div class="nav_t1" v-if="!$store.state.is_login" style="flex:0 0 auto">
      <span @click="jump('/login')"> <i class="el-icon-user"></i> {{this.$lang('50115')}}</span>
      |
      <span @click="jump('/reg')"> <i class="el-icon-edit-outline"></i> {{this.$lang('50118')}}</span>
    </div>
    <div class="user-dropdown" v-else>
      <div class="user-dropdown-toggle" @click="toggleDropdown">
        {{ info.nickname || info.mail}}
        <i class="dropdown-arrow" :class="{ 'open': dropdownOpen }"></i>
      </div>
      <div class="user-dropdown-menu" v-show="dropdownOpen">
        <div class="dropdown-item" @click="jump('/bus_list', {}, true)">
          <i class="icon-order"></i>
          {{this.$lang('37397')}}
        </div>
        <div class="dropdown-item" @click="jump('/personal', {}, true)">
          <i class="icon-user"></i>
          {{this.$lang('50117')}}
        </div>
        <div class="dropdown-item" @click="jump('/coupon', {}, true)">
          <i class="icon-ticket"></i>
          {{this.$lang('50045')}}
        </div>
        <div class="dropdown-item" @click="quit">
          <i class="icon-close"></i>
          {{this.$lang('42629')}}
        </div>
      </div>
    </div>

     


      <div class="lang-dropdown">
        <div class="lang-toggle" @click="langOpen = !langOpen">
          <span>{{ curLang.label }}</span>
          <i class="dropdown-arrow" :class="{ open: langOpen }"></i>
        </div>
        <div class="lang-menu" v-show="langOpen">
          <div v-for="itm in cities" :key="itm.value" class="lang-item"
               :class="{ active: itm.value === curLang.value }" @click="set_lang(itm.value)">
            <span class="lang-label">{{ itm.label }}</span>
            <i v-if="itm.value === curLang.value" class="el-icon-check"></i>
          </div>
        </div>
      </div>

    </div>
</div>

 
</template>

<script>
export default {
  name: 'nav_list',
  props :
    {
      index : {
        default : 0,
        type : Number,
      },
      theme : {
        default : 'light',
        type : String,
        validator: function (value) {
          return ['dark', 'light'].indexOf(value) !== -1
        }
      }
    },

  data() {
    return {
      info : {},
      lang:'',
      show : true,
      dropdownOpen: false,
      langOpen: false,
      cities: [{
          value: 'cn',
          label: '中文',
        },{
          value: 'jp',
          label: '日本語',
        },{
          value: 'kor',
          label: '한국어',
        },{
          value: 'tw',
          label: '繁體中文',
        },{
          value: 'en',
          label: 'English',
        },

        ],
    }
  },
  computed:{
    // 当前语言项：从 URL 前缀推导（cur_lang），用于下拉框回显
    curLang(){
      const lang = this.cur_lang()
      return this.cities.find(c => c.value === lang) || this.cities[0]
    }
  },
  methods:{
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    // 点击组件外部时收起所有下拉（用户菜单 + 语言菜单）
    handleClickOutside(e) {
      if (this.$el.contains(e.target)) return
      this.dropdownOpen = false
      this.langOpen = false
    },
    set_lang(v) {
      // 多语言切换：语言进 URL 前缀（/en/、/jp/、/tw/、/kor/，中文无前缀），整页跳转后由
      // main.js/router 按前缀重新初始化，保证各语言 URL 可被独立访问与收录
      const rest = location.pathname.replace(/^\/(en|jp|kor|tw)(\/|$)/, '/')
      const prefix = v === 'cn' ? '' : '/' + v
      const target = (prefix + (rest === '' ? '/' : rest)) + location.search
      if (target === location.pathname + location.search) {
        this.cache('lang_config', v)
        location.reload()
        return
      }
      location.href = target
    },
    quit() {
      this.$message({
        type: 'success',
        message: 'ok'
      });

      this.cache('info','');
      this.cache('token', '');
      this.$store.commit('quit')
      this.jump('/', {}, true)

    },
    langconf(){
      this.cache('set_lang', 1)
      this.cache('lang_config',this.lang);
      this.$forceUpdate();
      location.reload();
    },
    initialValue(){
      this.lang = this.cache('lang_config')
    },
  },
  mounted(){
    if (this.cache('token')) {
      this.$store.commit('login')
      this.info = this.cache('info')
    }
    if ( 'lang' in this.$route.query ) {
      if (!this.cache('set_lang')) {
        this.cache('lang_config', this.$route.query.lang)
        this.cache('set_lang', 0)
      }

    }

    this.initialValue()
    
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
}
</script>

<style scoped>
.lang_itm {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .lang_img {
    width: 25px;
    height: 15px;
  }
.m1 {
  box-shadow:0px 15px 20px -16px rgba(0, 0, 0, 0.25);
  width: 100%;
  display: flex;
  height: 120px;
  background-color: #ffffff;
}
.logo {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.logo a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
  font-family: 'v3ui';
  font-size: 20px;
  transition: all 0.3s ease;
}

.logo a:hover {
  color: #fff;
}

.logo img {
  width: 120px;
  height: auto;
  margin-right: 10px;
}
.nav {
  display: flex;
  background: #00000066;
  align-items: center;
  justify-content: space-between;
 
  padding: 0 4% ;
 
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  height: 80px;
}
.right_nav {
  display: flex;
  align-items: center;
}

.user-dropdown {
  position: relative;
  display: inline-block;
}

.user-dropdown-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 12px 20px;
  border-radius: 6px;
  transition: all 0.3s ease;
  color: #fff;
  font-size: 18px;
  font-family: Microsoft YaHei;
  white-space: nowrap;
}

.user-dropdown-toggle:hover {
  background: rgba(28, 80, 152, 0.05);
  transform: translateY(-1px);
}

.dropdown-arrow {
  margin-left: 8px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fff;
  transition: transform 0.3s ease;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.user-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  z-index: 1000;
  padding: 8px 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: #333;
  font-size: 14px;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.dropdown-item i {
  margin-right: 8px;
  width: 16px;
  text-align: center;
}

.icon-order::before {
  content: "📋";
}

.icon-user::before {
  content: "👤";
}

.icon-ticket::before {
  content: "🎫";
}

.icon-close::before {
  content: "✕";
}
 
.nav .nav_t1 {
  margin: 0 8px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  cursor: pointer;
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding: 10px 14px;
  border-radius: 6px;
  transition: all 0.3s ease;
  color: #fff;
}

.nav .nav_t1:hover {
  background: rgba(28, 80, 152, 0.05);
  transform: translateY(-1px);
}

.nav_act {
  font-weight: bold;
  color: #fff;
  background: rgba(28, 80, 152, 0.05);
  position: relative;
  transition: all 0.3s ease;
}

 
.nav .nav_t1  a{
  text-decoration-line: none;

}
 
.nav .nav_t1   .iconimg{


  width: 16px;
  margin-right: 4px;

}

.nav_sele {
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.15);
}
 
.lang-dropdown {
  position: relative;
  margin-left: 10px;
}

.lang-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid rgba(255,255,255,0.4);
  color: #fff;
  font-size: 13px;
  transition: all 0.2s ease;
}

.lang-toggle:hover {
  background: rgba(255,255,255,0.1);
}

.lang-toggle span {
  white-space: nowrap;
}

.lang-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  min-width: 130px;
  z-index: 1000;
  padding: 6px 0;
}

.lang-item {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  transition: background 0.2s ease;
  white-space: nowrap;
}

.lang-item:hover {
  background: rgba(0,0,0,0.05);
}

.lang-item.active {
  color: #1c5098;
  font-weight: bold;
}

.lang-item .lang-label {
  flex: 1;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

/* Light theme styles */
.nav-light {
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.nav-light .logo a {
  color: #333;
}

.nav-light .logo a:hover {
  color: #333;
}

.nav-light .nav_t1 {
  color: #333;
}

.nav-light .nav_t1:hover {
  background: rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}

.nav-light .nav_act {
  color: #333;
  background: rgba(0, 0, 0, 0.05);
}

.nav-light .user-dropdown-toggle {
  color: #333;
}

.nav-light .user-dropdown-toggle:hover {
  background: rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}

.nav-light .dropdown-arrow {
  border-top: 4px solid #333;
}

.nav-light .lang-toggle {
  border-color: rgba(0,0,0,0.2);
  color: #333;
}

.nav-light .lang-toggle:hover {
  background: rgba(0,0,0,0.05);
}
</style>



// WEBPACK FOOTER //
// src/pages/index/nav_list.vue